module.exports = __webpack_public_path__ + "static/media/INVENTORY-COST-OF-GOODS.1e242acc.svg";